import React from "react";

class Banner extends React.Component {
  render() {
    return (
      <section className="dashboard-section">
        {/* <div className="bg-overlay" /> */}
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
            &nbsp;&nbsp;
              {/* <div className="text-white text-center">
                <h2 className="font-weight-bold fonts-italic">
                  Connect to internet with your smartphone
                </h2>
                <div className="home_divider mt-3 mb-3 mx-auto" />
              </div>
              */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/rechargeCheckout/Banner.js